import React from 'react';
import Hero from '../components/Hero/Hero';
import PropertyList from '../components/PropertyList/PropertyList';

const HomePage = () => {
  return (
    <>
      <Hero />
      <PropertyList />
    </>
  );
};

export default HomePage;
